<template lang="pug">
b-modal#paymentOptionUpdate(
  ref="paymentOptionUpdate"
  :title="$t('ui.combine.payment_option_callback_update')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  size="xl"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.payment_mode')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="payment_mode"
        type="text"
        :dirty="$v.payment_mode.$dirty"
        :error="$v.payment_mode.$error"
        v-model.trim.lazy="$v.payment_mode.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.payment_mode" :name="$t('ui.payment_mode')")
    .row
      .col-6
        b-form-group(:label="$tc('ui.url_callback_deposit')").mb-0
          DebounceInput(
            size="sm"
            ref="url_callback_deposit"
            type="text"
            :dirty="$v.url_callback_deposit.$dirty"
            :error="$v.url_callback_deposit.$error"
            v-model.trim.lazy="$v.url_callback_deposit.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.url_callback_deposit" :name="$t('ui.url_callback_deposit')")
        b-form-group(:label="$tc('ui.url_callback_withdrawal')").mb-0
          DebounceInput(
            size="sm"
            ref="url_callback_withdrawal"
            type="text"
            :dirty="$v.url_callback_withdrawal.$dirty"
            :error="$v.url_callback_withdrawal.$error"
            v-model.trim.lazy="$v.url_callback_withdrawal.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.url_callback_withdrawal" :name="$t('ui.url_callback_withdrawal')")    
        b-form-group(:label="$tc('ui.url_callback_affiliate')").mb-0
          DebounceInput(
            size="sm"
            ref="url_callback_affiliate"
            type="text"
            :dirty="$v.url_callback_affiliate.$dirty"
            :error="$v.url_callback_affiliate.$error"
            v-model.trim.lazy="$v.url_callback_affiliate.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.url_callback_affiliate" :name="$t('ui.url_callback_affiliate')")
        b-form-group(:label="$tc('ui.url_api_freecredit')").mb-0
          DebounceInput(
            size="sm"
            ref="url_callback_free_credit"
            type="text"
            :dirty="$v.url_callback_free_credit.$dirty"
            :error="$v.url_callback_free_credit.$error"
            v-model.trim.lazy="$v.url_callback_free_credit.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.url_callback_free_credit" :name="$t('ui.url_api_freecredit')")
      .col-6
        b-form-group(:label="$tc('ui.url_api_deposit')").mb-0
          DebounceInput(
            size="sm"
            ref="url_api_deposit"
            type="text"
            :dirty="$v.url_api_deposit.$dirty"
            :error="$v.url_api_deposit.$error"
            v-model.trim.lazy="$v.url_api_deposit.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.url_api_deposit" :name="$t('ui.url_api_deposit')")
        b-form-group(:label="$tc('ui.url_api_withdrawal')").mb-0
          DebounceInput(
            size="sm"
            ref="url_api_withdrawal"
            type="text"
            :dirty="$v.url_api_withdrawal.$dirty"
            :error="$v.url_api_withdrawal.$error"
            v-model.trim.lazy="$v.url_api_withdrawal.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.url_api_withdrawal" :name="$t('ui.url_api_withdrawal')")
        b-form-group(:label="$tc('ui.url_api_balance')").mb-0
          DebounceInput(
            size="sm"
            ref="url_api_balance"
            type="text"
            :dirty="$v.url_api_balance.$dirty"
            :error="$v.url_api_balance.$error"
            v-model.trim.lazy="$v.url_api_balance.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.url_api_balance" :name="$t('ui.url_api_balance')")
        b-form-group(:label="$tc('ui.url_callback_voucher')").mb-0
          DebounceInput(
            size="sm"
            ref="url_callback_voucher"
            type="text"
            :dirty="$v.url_callback_voucher.$dirty"
            :error="$v.url_callback_voucher.$error"
            v-model.trim.lazy="$v.url_callback_voucher.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.url_callback_voucher" :name="$t('ui.url_callback_voucher')")
    .row
      .col-3
        b-form-group(:label="$tc('ui.prefix_deposit')").mb-0
          DebounceInput(
            size="sm"
            ref="prefix_deposit"
            type="text"
            :dirty="$v.prefix_deposit.$dirty"
            :error="$v.prefix_deposit.$error"
            v-model.trim.lazy="$v.prefix_deposit.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.prefix_deposit" :name="$t('ui.prefix_deposit')")
      .col-3
        b-form-group(:label="$tc('ui.prefix_withdrawal')").mb-0
          DebounceInput(
            size="sm"
            ref="prefix_withdrawal"
            type="text"
            :dirty="$v.prefix_withdrawal.$dirty"
            :error="$v.prefix_withdrawal.$error"
            v-model.trim.lazy="$v.prefix_withdrawal.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.prefix_withdrawal" :name="$t('ui.prefix_withdrawal')")
      .col-3
        b-form-group(:label="$tc('ui.prefix_affiliate')").mb-0
          DebounceInput(
            size="sm"
            ref="prefix_affiliate"
            type="text"
            :dirty="$v.prefix_affiliate.$dirty"
            :error="$v.prefix_affiliate.$error"
            v-model.trim.lazy="$v.prefix_affiliate.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.prefix_affiliate" :name="$t('ui.prefix_affiliate')")
      .col-3
        b-form-group(:label="$tc('ui.prefix_freecredit')").mb-0
          DebounceInput(
            size="sm"
            ref="prefix_free_credit"
            type="text"
            :dirty="$v.prefix_free_credit.$dirty"
            :error="$v.prefix_free_credit.$error"
            v-model.trim.lazy="$v.prefix_free_credit.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.prefix_free_credit" :name="$t('ui.prefix_freecredit')")
      .col-3
        b-form-group(:label="$tc('ui.prefix_delimiter')").mb-0
          DebounceInput(
            size="sm"
            ref="prefix_delimiter"
            type="text"
            :dirty="$v.prefix_delimiter.$dirty"
            :error="$v.prefix_delimiter.$error"
            v-model.trim.lazy="$v.prefix_delimiter.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.prefix_delimiter" :name="$t('ui.prefix_delimiter')")
      .col-3
        b-form-group(:label="$tc('ui.prefix_voucher')").mb-0
          DebounceInput(
            size="sm"
            ref="prefix_voucher"
            type="text"
            :dirty="$v.prefix_voucher.$dirty"
            :error="$v.prefix_voucher.$error"
            v-model.trim.lazy="$v.prefix_voucher.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.prefix_voucher" :name="$t('ui.prefix_voucher')")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, minValue, maxValue, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  props: { 
    item: {
      type: Object,
      default: null
    }
   },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      payment_mode: "",
      url_callback_deposit: null,
      url_callback_withdrawal: null,
      url_callback_affiliate: null,
      url_api_deposit: null,
      url_api_withdrawal: null,
      url_api_balance: null,
      prefix_deposit: null,
      prefix_withdrawal: null,
      prefix_affiliate: null,
      prefix_delimiter: null,
      url_callback_free_credit: null,
      prefix_free_credit: null,
      url_callback_voucher: null,
      prefix_voucher: null
    };
  },
  computed: { 
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    payment_mode: {
      required
    },
    url_callback_deposit: {
      maxLength: maxLength(100)
    },
    url_callback_withdrawal: {
      maxLength: maxLength(100)
    },
    url_callback_affiliate: {
      maxLength: maxLength(100)
    },
    url_api_deposit: {
      maxLength: maxLength(100)
    },
    url_api_withdrawal: {
      maxLength: maxLength(100)
    },
    url_api_balance: {
      maxLength: maxLength(100)
    },
    prefix_deposit: {
      maxLength: maxLength(10)
    },
    prefix_withdrawal: {
      maxLength: maxLength(10)
    },
    prefix_affiliate: {
      maxLength: maxLength(10)
    },
    prefix_delimiter: {
      maxLength: maxLength(2)
    },
    url_callback_free_credit: {
      maxLength: maxLength(100)
    },
    prefix_free_credit: {
      maxLength: maxLength(10)
    },
    url_callback_voucher: {
      maxLength: maxLength(100)
    },
    prefix_voucher: {
      maxLength: maxLength(10)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.paymentOptionGlobalUpdateUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          payment_mode: this.payment_mode,
          url_callback_deposit: this.url_callback_deposit,
          url_callback_withdrawal: this.url_callback_withdrawal,
          url_callback_affiliate: this.url_callback_affiliate,
          url_api_deposit: this.url_api_deposit,
          url_api_withdrawal: this.url_api_withdrawal,
          url_api_balance: this.url_api_balance,
          prefix_deposit: this.prefix_deposit,
          prefix_withdrawal: this.prefix_withdrawal,
          prefix_affiliate: this.prefix_affiliate,
          prefix_delimiter: this.prefix_delimiter,
          url_callback_free_credit: this.url_callback_free_credit,
          prefix_free_credit: this.prefix_free_credit,
          url_callback_voucher: this.url_callback_voucher,
          prefix_voucher: this.prefix_voucher
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.paymentOptionUpdate.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  if(response.data.status == -9) {
                    this.$emit("failed", "payment_option_callback_update", response.data.statusdesc);
                  } else {
                    this.$emit("failed", "payment_option_callback_update", this.feedback.status);
                  }
                  this.$refs.paymentOptionUpdate.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.payment_mode = this.item.payment_mode;
      this.url_callback_deposit = this.item.url_callback_d;
      this.url_callback_withdrawal = this.item.url_callback_w;
      this.url_callback_affiliate = this.item.url_callback_aff;
      this.url_api_deposit = this.item.url_api_d;
      this.url_api_withdrawal = this.item.url_api_w;
      this.url_api_balance = this.item.url_api_bal;
      this.prefix_deposit = this.item.prefix_d;
      this.prefix_withdrawal = this.item.prefix_w;
      this.prefix_affiliate = this.item.prefix_aff;
      this.prefix_delimiter = this.item.prefix_delimiter;
      this.url_callback_free_credit = this.item.url_callback_fc;
      this.prefix_free_credit = this.item.prefix_fc;
      this.url_callback_voucher = this.item.url_callback_vch;
      this.prefix_voucher = this.item.prefix_vch;
    }
  }
};
</script>